document.addEventListener('DOMContentLoaded', function() {
        const states = window.theme.states;
        const dataProvinces = states.match(/data-provinces="([^"]+)"/)[1];
        const decodedProvinces = dataProvinces.replace(/&quot;/g, '"');
        const statesArray = JSON.parse(decodedProvinces).map(item => item[0]);
        const filteredStates = statesArray.filter(state =>
        !["American Samoa", "Armed Forces Americas", "Armed Forces Europe", "Armed Forces Pacific", "District of Columbia", "Federated States of Micronesia", "Guam", "Marshall Islands", "Northern Mariana Islands", "Palau", "Puerto Rico", "U.S. Virgin Islands", "Virgin Islands"].includes(state)
        );

        const selectElement = document.querySelector('.locations__stores--select');
        filteredStates.forEach(state => {
        const option = document.createElement('option');
        option.value = state;
        option.textContent = state;
        selectElement.appendChild(option);
    });

        document.querySelector('.locations__stores--select').addEventListener('change', function () {
        const selectedState = this.value;
        const stores = document.querySelectorAll('.location__store');
        const noLocationsDiv = document.querySelector('.no-locations');

        let visibleStores = 0;

        stores.forEach(store => {
        if (selectedState === "Select state") {
        store.style.display = "block";
        visibleStores++;
    } else {
        if (store.getAttribute('data-state') === selectedState) {
        store.style.display = "block";
        visibleStores++;
    } else {
        store.style.display = "none";
    }
    }
    });

        if (visibleStores === 0) {
        noLocationsDiv.classList.remove('hidden');
    } else {
        noLocationsDiv.classList.add('hidden');
    }
    });

});